import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import styles from 'components/medicalHistory/page.module.scss';
import Stack from '@mui/material/Stack';
import Button from 'components/common/button';
import SearchableTextBox from 'components/common/searchableTextBox';
import { filterIntakeFormSettings } from 'utils/helper';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import {
  StateTypeLocalStorage,
  usePersistMHReducer,
} from 'reducer/medicalHistory';
import MetaTag from 'components/meta';
import { NullablePatientDTO } from 'types/patients';

type OptionType = {
  value: string;
  label: string;
};

type Props = {
  nextPage: number;
  currentPage: number;
  actionPage: string;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

function MedicalHistoryScreen({
  nextPage,
  nextOrSubmitButton,
  actionPage,
}: Props) {
  const intakeFormSettings = useSelector(
    (state: RootState) => state.intakeFormSettings.value,
  );

  const patient = useSelector(
    (state: RootState) => state.patient,
  ) as NullablePatientDTO;

  const [medicalHistory, setMedicalHistory] = useState<OptionType[]>([]);

  const [state, dispatch] = usePersistMHReducer();
  const [options, setOptions] = useState<OptionType[]>([]);

  useEffect(() => {
    if (intakeFormSettings) {
      const medicalHistorySettings = filterIntakeFormSettings(
        intakeFormSettings,
        'medicalHistorySettings',
      );
      const mapMedicalHistory = medicalHistorySettings.map((item: {conditionName: string}) => ({
        value: item.conditionName,
        label: item.conditionName,
      }));

      setOptions(mapMedicalHistory);
    }
  }, []);

  const clickNextOrSubmit = async (nextPage: number) => {
    await dispatch({
      type: actionPage,
      name: 'Medical History',
      value: medicalHistory,
    });
    nextOrSubmitButton(nextPage);
  };

  const getMedicalHistoryItem = (items: OptionType[]) => {
    setMedicalHistory(items);
  };

  useEffect(() => {
    if (state) {
      const medicalHistory = state.find(
        (p: StateTypeLocalStorage) => p.name === actionPage,
      );
      if (medicalHistory?.value.length) {
        setMedicalHistory(medicalHistory.value);
      } else {
        const mappingData = patient?.medicalHistories.map((item) => (
          {
            value: item?.conditionName ?? '',
            label: item?.conditionName ?? '',
          }
        ));
        if (mappingData) {
          setMedicalHistory(mappingData);
        }
      }
    }
  }, []);

  return (
    <>
      <MetaTag title="Medical History" />
      <Box pb={3} mb={4}>
        <Box>
          <h2 className={`marginTopZero ${styles.titleText}`}>
            Medical History
          </h2>
          <p className={styles.titleTextSubText}>Choose all that apply</p>
          <Stack>
            <SearchableTextBox
              option={options}
              id="medical-history"
              placeholder="Search for conditions"
              onChange={getMedicalHistoryItem}
              value={medicalHistory}
              isInputField
            />
            <p className={styles.separator} />
          </Stack>
        </Box>
        <div className="next-button-fixed">
          <Button
            onClick={() => clickNextOrSubmit(nextPage)}
          >
            Next
          </Button>
        </div>
      </Box>
    </>
  );
}

export default MedicalHistoryScreen;
